// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoJnTsVeCJyPOm {
  display: inline-flex;
  margin-left: var(--ds-space-050, 4px);
  animation: tGq5szPRO9qEru 0.2s ease-in-out;
}
@media print {
  .LoJnTsVeCJyPOm {
    display: none;
  }
}
.pTZkDcnKGcWs3U {
  padding: var(--ds-space-0, 0px);
}
.pTZkDcnKGcWs3U:hover {
  border: none;
  background-color: transparent;
}
@keyframes tGq5szPRO9qEru {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
`, ""]);
// Exports
export var copyCommentWrapper = `LoJnTsVeCJyPOm`;
export var slideFromLeft = `tGq5szPRO9qEru`;
export var copyLinkButton = `pTZkDcnKGcWs3U`;
export default ___CSS_LOADER_EXPORT___;
